$(document).ready(function () {
  $('.live-match-box').each(function () {
    const $section = $(this);
    const $slider = $section.find('.match-slider');
    const $thumbs = $section.find('.match-thumb-slider');
    const $current = $section.find('.current-slide');
    const $total = $section.find('.total-slides');
    const box = this;

    if (!$slider.length || !$thumbs.length) {
      return;
    }

    // Local date rewrite
    $slider.find('.match-slide[data-match-date]').each(function () {
      const d = new Date(this.dataset.matchDate);
      const items = $(this).find('.match-date ul li');
      items.eq(0).text(d.toLocaleDateString([], { day: 'numeric', month: 'long', year: 'numeric' }));
      items.eq(1).text(d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }));
    });

    // Dwell time
    let dwellStart = null;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          dwellStart = Date.now();
        } else if (dwellStart) {
          dataLayer.push({ event: 'hero_dwell', dwell_seconds: Math.round((Date.now() - dwellStart) / 1000) });
          dwellStart = null;
        }
      });
    }, { threshold: 0.3 }).observe(box);

    window.addEventListener('pagehide', function () {
      if (dwellStart) dataLayer.push({ event: 'hero_dwell', dwell_seconds: Math.round((Date.now() - dwellStart) / 1000) });
    });

    // Match nav + Shop click tracking
    $(box).on('click', '[data-track]', function () {
      dataLayer.push(JSON.parse(this.dataset.track));
    });

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      const current = (currentSlide || 0) + 1;
      $current.text(current);
      $total.text(slick.slideCount);

      $section.find('.match-thumb').removeClass('is-active').attr('aria-current', 'false');

      const activeIndex = slick.currentSlide || 0;

      $section
        .find('.match-thumb-item')
        .eq(activeIndex)
        .find('.match-thumb')
        .addClass('is-active')
        .attr('aria-current', 'true');
    });

    $thumbs.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: $slider,
      focusOnSelect: true,
      arrows: false,
      dots: false,
      infinite: false,
      variableWidth: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: $thumbs,
      arrows: true,
      prevArrow: $section.find('.match-prev'),
      nextArrow: $section.find('.match-next'),
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      speed: 200,
      cssEase: 'ease-out'
    });
  });
});

const PERIOD_LABELS = {
  1: 'Scheduled', 2: 'Pre-Match', 3: '1H', 4: 'HT', 5: '2H',
  6: 'ET', 7: 'ET 1H', 8: 'ET HT', 9: 'ET 2H', 10: 'FT',
  11: 'Pens', 12: 'Post-Match', 13: 'Abandoned'
};

function getLiveScore(homeTeamName, awayTeamName, liveMatches) {
  const match = liveMatches.find(m => {
    if (m.MatchStatus !== 3) return false;
    const apiHome = TEAM_ID_LOOKUP[m.HomeTeam.IdTeam];
    const apiAway = TEAM_ID_LOOKUP[m.AwayTeam.IdTeam];
    return apiHome === homeTeamName && apiAway === awayTeamName;
  });

  if (!match) return null;

  const periodLabel = PERIOD_LABELS[match.Period] || '';
  const progress = match.Period === 4 || match.Period === 8
    ? periodLabel                          // "HT" — no minute makes sense here
    : `${periodLabel} ${match.MatchTime || ''}`.trim();  // "1H 19'"

  return [match.HomeTeam.Score ?? 0, match.AwayTeam.Score ?? 0, progress];
}

const TEAM_ID_LOOKUP = {
  // CAF
  "43879": "Senegal", "43872": "Morocco", "43854": "Côte d'Ivoire", "43860": "Ghana",
  "43843": "Algeria", "43883": "South Africa", "43850": "Cabo Verde", "43888": "Tunisia",
  "20014": "Congo DR", "43855": "Egypt",
  // CONCACAF
  "43914": "Panama", "43911": "Mexico", "43921": "USA", "43899": "Canada",
  "43908": "Haiti", "1895293": "Curaçao",
  // CONMEBOL
  "43928": "Paraguay", "43927": "Ecuador", "43930": "Uruguay", "43926": "Colombia",
  "43924": "Brazil", "43922": "Argentina",
  // OFC
  "43978": "New Zealand",
  // AFC
  "43822": "Korea Republic", "43819": "Japan", "43817": "IR Iran", "43818": "Iraq",
  "43835": "Saudi Arabia", "43976": "Australia", "44005": "Uzbekistan",
  "43820": "Jordan", "43834": "Qatar",
  // UEFA
  "43946": "France", "43971": "Switzerland", "43942": "England", "43938": "Croatia",
  "43960": "Netherlands", "43970": "Sweden", "43934": "Austria", "43972": "Türkiye",
  "43995": "Czechia", "43963": "Portugal", "43967": "Scotland", "43969": "Spain",
  "44037": "Bosnia and Herzegovina", "43935": "Belgium", "43961": "Norway", "43948": "Germany"
};